export enum SortOrderEnum {
    ASC = 1,
    DESC = 2,
}

export const sortOrderNames: Record<SortOrderEnum, string> = {
    [SortOrderEnum.ASC]: 'uiKit.table.tableSettings.sortBy.sortAscending',
    [SortOrderEnum.DESC]: 'uiKit.table.tableSettings.sortBy.sortDescending',
};

export const sortOrderOptions: { text: string; value: SortOrderEnum; icon: string; iconPos: 'left' | 'right' }[] = [
    { text: 'Ascending', value: SortOrderEnum.ASC, icon: 'fa-light fa-arrow-up', iconPos: 'right' },
    { text: 'Descending', value: SortOrderEnum.DESC, icon: 'fa-light fa-arrow-down', iconPos: 'right' },
];
